import React, { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import App from 'wb-spotify/app/app';
import {
	BrowserRouter,
} from 'react-router-dom';

import * as Sentry from '@sentry/react';

import '@aleph/supergrid/style.css';
import 'wb-reddit/styles.scss';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'rsuite/dist/rsuite.min.css';
import GeneralError from 'wb-reddit/app/common/components/generalError';
import { ErrorBoundary } from '@sentry/react';
import { ToastContainer } from 'react-toastify';
import { i18n, setAppEnv, AlephToastContainer } from '@aleph/shared-components';
import { I18nextProvider } from 'react-i18next';

setAppEnv(import.meta.env.VITE_PACKAGE_APP);

if (import.meta.env.VITE_PRODUCTION === 'true') {
	Sentry.init({
		dsn:          'https://0937724c2725b502e35e4a85258993a7@o1128294.ingest.us.sentry.io/4510078608408577',
		integrations: [
			new Sentry.Replay({
				maskAllText:            false,
				blockAllMedia:          false,
				maskAllInputs:          false,
				networkDetailAllowUrls: [`${import.meta.env.VITE_API_PATH}/graphql/pn_sp/`],
				networkRequestHeaders:  ['X-Custom-Header'],
				networkResponseHeaders: ['X-Custom-Header'],
			}),
			new Sentry.BrowserTracing(),
		],
		tracesSampleRate:         1.0,
		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1.0,
		environment:              import.meta.env.VITE_ENVIRONMENT,
		dist:                     import.meta.env.VITE_DATACENTER,
	});
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
	<StrictMode>
		<I18nextProvider i18n={i18n}>
			<ErrorBoundary fallback={({ error }) => (<GeneralError error={error} />)}>
				<BrowserRouter>
					<App />
				</BrowserRouter>
				<ToastContainer
					closeButton={false}
					style={{
						maxWidth:      '50%',
						width:         'fit-content',
						display:       'flex',
						flexDirection: 'column',
						alignItems:    'end',
						margin:        0,
						padding:       0,
					}}
				/>
				<AlephToastContainer />
			</ErrorBoundary>
		</I18nextProvider>
	</StrictMode>,
);
